import { isAuthorized } from '@/utilities/helpers'

export default {
  name: 'advanced-settings',
  props: {
    signedInUser: Object
  },
  computed: {
    isSuperAdmin () {
      return isAuthorized(this.signedInUser, 'superadmin')
    },
    showSimulators () {
      return process.env.VUE_APP_ENV !== 'production'
    }
  }
}
